import UpdateUserConfigurationJsonResponse from 'owa-service/lib/contract/UpdateUserConfigurationJsonResponse';
import UserConfigurationDictionaryEntry from 'owa-service/lib/contract/UserConfigurationDictionaryEntry';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import updateUserConfigurationJsonRequest from 'owa-service/lib/factory/updateUserConfigurationJsonRequest';
import updateUserConfigurationOperation from 'owa-service/lib/operation/updateUserConfigurationOperation';
import updateUserConfigurationOwaRequest from 'owa-service/lib/factory/updateUserConfigurationOwaRequest';
import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';

export default function updateUserConfiguration(
    configurationName: string,
    changes: UserConfigurationDictionaryEntry[]
): Promise<UpdateUserConfigurationJsonResponse> {
    return updateUserConfigurationOperation(
        updateUserConfigurationJsonRequest({
            Header: getJsonRequestHeader(),
            Body: updateUserConfigurationOwaRequest({
                UserConfiguration: serviceUserConfiguration({
                    UserConfigurationName: userConfigurationNameType({
                        BaseFolderId: distinguishedFolderId({
                            Id: 'root',
                        }),
                        Name: configurationName,
                    }),
                    Dictionary: changes,
                }),
            }),
        })
    );
}
